const FilterIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 13H6C5.4 13 5 12.6 5 12C5 11.4 5.4 11 6 11H18C18.6 11 19 11.4 19 12C19 12.6 18.6 13 18 13Z'
        fill='black'
      />
      <path
        d='M15 19H9C8.4 19 8 18.6 8 18C8 17.4 8.4 17 9 17H15C15.6 17 16 17.4 16 18C16 18.6 15.6 19 15 19Z'
        fill='black'
      />
      <path
        d='M21 7H3C2.4 7 2 6.6 2 6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6C22 6.6 21.6 7 21 7Z'
        fill='black'
      />
    </svg>
  )
}

export default FilterIcon
